import React, { useEffect, useState } from 'react'
import { FormFieldType } from '@App/forms/v2/common/form-field'
import FormFieldFromProps from '@Fields/v2/FormFieldFromProps'
import { useFormContext } from 'react-hook-form'
import { CreateRightsholderForm } from '@Entities/schemas/rightsholder/create-rightsholder'
import ModalPortal from '@Components/Popups/ModalPortal'
import RegistrationPopup from '@Scenes/RightsholderRegistrationLayout/RegistrationPopup'

interface MemberDetailsSectionProps {
    memberType: FormFieldType<unknown> | null
    memberSubType: FormFieldType<unknown>
    name: FormFieldType<string>
}

const MemberDetailsSection = (props: MemberDetailsSectionProps) => {
    const { watch, setValue } = useFormContext<CreateRightsholderForm>()

    const { memberType, memberSubType, name } = props
    const [popupIsOpen, setPopupIsOpen] = useState<boolean>(false)
    const [showMemberSubType, setShowMemberSubType] = useState<boolean>(false)
    const [notEligible, setNotEligible] = useState<boolean>(false)

    const memberTypeValue = watch('memberType')
    const memberSubTypeValue = watch('memberSubType')

    const closePopup = () => {
        setValue('memberSubType', '')
        setPopupIsOpen(false)
    }

    const determineIsCMOorPublisher = () => {
        const isCMOorPublisherLocal =
            memberTypeValue === 'CMO' || memberTypeValue === 'Publisher' || memberTypeValue === 'Administrator'
        setShowMemberSubType(isCMOorPublisherLocal)
        if (isCMOorPublisherLocal) {
            setValue('memberSubType', 'Self Administered')
        }
        return isCMOorPublisherLocal
    }

    const determineNotEligible = () => {
        const notEligibleLocal = memberSubTypeValue === 'Fully Administered'
        setNotEligible(notEligibleLocal)
        if (notEligibleLocal) {
            setPopupIsOpen(true)
        }
    }

    const determineIdontKnow = () => {
        if (memberSubTypeValue === "I don't know") {
            setNotEligible(false)
            setPopupIsOpen(true)
        }
    }

    useEffect(() => {
        determineIsCMOorPublisher()
        determineNotEligible()
        determineIdontKnow()
    }, [memberSubTypeValue, memberTypeValue])

    return (
        <>
            <div className="member-setails-section">
                {memberType && <FormFieldFromProps field={memberType} />}
                {!showMemberSubType && <FormFieldFromProps field={memberSubType} />}
                <FormFieldFromProps field={name} />
            </div>
            <ModalPortal isOpen={popupIsOpen}>
                <RegistrationPopup closePopup={closePopup} notEligible={notEligible} />
            </ModalPortal>
        </>
    )
}

export default MemberDetailsSection
